export default {
  missingMarketsOrCategories: {
    id: 'bo_seller-options-shipping-missing_markets_or_categories',
    defaultMessage:
      'Start selling in these markets and categories by adding shipping rules.',
  },
} as const
